import { useState } from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { Header, PaginationHelper, TitleBar } from "webapp/components";
import { CIBCMemberSearchForm } from "webapp/components/Partner/CIBC/CIBCMemberSearchForm/Index";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function CIBCMemberSearch(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  // const [decalNumber, setDecalNumber] = useState(
  //   props.context.state.MemberLookup.decalNumber ||
  //     props.context.state.decalNumber ||
  //     ""
  // );

  const [memberNumber, setMemberNumber] = useState(
    props.context.state.MemberLookup.memberNumber || props.context.state.memberNumber || "",
  );

  const [firstName, setFirstName] = useState(
    props.context.state.MemberLookup.FirstName || props.context.state.FirstName || "",
  );

  const [lastName, setLastName] = useState(
    props.context.state.MemberLookup.LastName || props.context.state.LastName || "",
  );

  const [searchType, setSearchType] = useState(
    props.context.state.MemberLookup.searchType || props.context.state.searchType || "",
  );

  const [phoneNum, setPhoneNum] = useState(
    props.context.state.MemberLookup.phoneNum || props.context.state.phoneNum || "",
  );
  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    devLog("formRef", formRef);
    if (typeof formRef.onUserNext === "function") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      // if (typeof data.decalNumber === "string") {
      //   setDecalNumber(data.decalNumber);
      // }
      if (typeof data.memberNumber === "string") {
        setMemberNumber(data.memberNumber);
      }
      if (typeof data.firstName === "string") {
        setFirstName(data.firstName);
      }
      if (typeof data.lastName === "string") {
        setLastName(data.lastName);
      }
      if (typeof data.searchType === "string") {
        setSearchType(data.searchType);
      }
      if (typeof data.phoneNum === "string") {
        setPhoneNum(data.phoneNum);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);
    onFormUpdate(data);
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle;
    context.setState(
      {
        webAppState: nextState,
        // FirstName: !!data.firstName ? data.firstName : context.state.firstName,
        // LastName: !!data.lastName ? data.lastName : context.state.lastName,
        MemberLookup: {
          memberNumber: data.memberNumber,
          firstName: data.firstName,
          lastName: data.lastName,
          searchType: data.searchType,
          phoneNum: data.phoneNum,
        },
      },
      () => {
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("APIA.ContractSearch.TitleBar2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div>
      <Header currState={props.currState} onUserBack={onUserBack} information={t("APIA.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />
      <CIBCMemberSearchForm
        memberNumber={memberNumber}
        firstName={firstName}
        lastName={lastName}
        phoneNum={phoneNum}
        searchType={searchType}
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onFormSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
        currState={props.currState}
      />
    </div>
  );
}

export default CIBCMemberSearch;
